// extracted by mini-css-extract-plugin
export var mainContainer = "index-module--mainContainer--3bk13";
export var buttonContainer = "index-module--buttonContainer--29R7S";
export var buttonContainer_solid = "index-module--buttonContainer_solid--1GcS7";
export var button = "index-module--button--2U7Rs";
export var nav = "index-module--nav--314UQ";
export var item = "index-module--item--3EUA8";